<template>
  <b-container id="control-panel" fluid>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title v-translate>Shippings CONFIRMED</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = shippingsConfirmedDanger"><b-badge variant="danger">{{shippingsConfirmedDanger.length}}</b-badge> > 60 min</b-link></span>
              <span v-if="shippingsConfirmedDanger.length === 1 && shippingsConfirmedDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsConfirmedDanger[0].id } }" target="_blank">#{{shippingsConfirmedDanger[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsConfirmedDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = shippingsConfirmedWarning"><b-badge variant="warning">{{shippingsConfirmedWarning.length}}</b-badge> > 30 min</b-link></span>
              <span v-if="shippingsConfirmedWarning.length === 1 && shippingsConfirmedWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsConfirmedWarning[0].id } }" target="_blank">#{{shippingsConfirmedWarning[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsConfirmedWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingConfirmedDetail @click.prevent="showingConfirmed = shippingsConfirmedSuccess"><b-badge variant="success">{{shippingsConfirmedSuccess.length}}</b-badge> &lt; 30 min</b-link></span>
              <span v-if="shippingsConfirmedSuccess.length === 1 && shippingsConfirmedSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsConfirmedSuccess[0].id } }" target="_blank">#{{shippingsConfirmedSuccess[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsConfirmedSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card><b-card>
          <b-card-title v-translate>Shippings ATPICKUPPOINT</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtPickupPointDetail @click.prevent="showingAtPickupPoint = shippingsAtPickupPointDanger"><b-badge variant="danger">{{shippingsAtPickupPointDanger.length}}</b-badge> > 60 min</b-link></span>
              <span v-if="shippingsAtPickupPointDanger.length === 1 && shippingsAtPickupPointDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsAtPickupPointDanger[0].id } }" target="_blank">#{{shippingsAtPickupPointDanger[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsAtPickupPointDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtPickupPointDetail @click.prevent="showingAtPickupPoint = shippingsAtPickupPointWarning"><b-badge variant="warning">{{shippingsAtPickupPointWarning.length}}</b-badge> > 30 min</b-link></span>
              <span v-if="shippingsAtPickupPointWarning.length === 1 && shippingsAtPickupPointWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsAtPickupPointWarning[0].id } }" target="_blank">#{{shippingsAtPickupPointWarning[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsAtPickupPointWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtPickupPointDetail @click.prevent="showingAtPickupPoint = shippingsAtPickupPointSuccess"><b-badge variant="success">{{shippingsAtPickupPointSuccess.length}}</b-badge> &lt; 30 min</b-link></span>
              <span v-if="shippingsAtPickupPointSuccess.length === 1 && shippingsAtPickupPointSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsAtPickupPointSuccess[0].id } }" target="_blank">#{{shippingsAtPickupPointSuccess[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsAtPickupPointSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card>
          <b-card-title v-translate>On INCIDENCE</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIncidencesDetail @click.prevent="showIncidencesId = 1"><b-badge :variant="incidencesCount[1] === 0 ? 'success' : 'danger'">{{incidencesCount[1]}}</b-badge> <translate>Taken by mistake</translate></b-link></span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIncidencesDetail @click.prevent="showIncidencesId = 7"><b-badge :variant="incidencesCount[7] === 0 ? 'success' : 'danger'">{{incidencesCount[7]}}</b-badge> <translate>Wrong size</translate></b-link></span>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col>
        <b-card v-if="ecosystemModules.tours.self">
          <b-card-title v-translate>Tours CONFIRMED</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalTourConfirmedDetail @click.prevent="showingToursConfirmed = toursConfirmedDanger"><b-badge variant="danger">{{toursConfirmedDanger.length}}</b-badge> > 60 min</b-link></span>
              <span v-if="toursConfirmedDanger.length === 1 && toursConfirmedDanger[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ToursEdit', params: { id: toursConfirmedDanger[0].id } }" target="_blank">#{{toursConfirmedDanger[0].id | uuid}}</b-link>
                &raquo;
                <span v-translate="{count: toursConfirmedDanger[0].count}">%{count} shipments</span>
                <span v-if="toursConfirmedDanger[0].courier_id">&raquo;
                  <b-link :to="{ name: 'UsersEdit', params: { id: toursConfirmedDanger[0].courier_id } }" target="_blank" v-if="toursConfirmedDanger[0].courier_id">{{toursConfirmedDanger[0].courier.name}}</b-link> <a v-if="toursConfirmedDanger[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursConfirmedDanger[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursConfirmedDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalTourConfirmedDetail @click.prevent="showingToursConfirmed = toursConfirmedWarning"><b-badge variant="warning">{{toursConfirmedWarning.length}}</b-badge> > 30 min</b-link></span>
              <span v-if="toursConfirmedWarning.length === 1 && toursConfirmedWarning[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ToursEdit', params: { id: toursConfirmedWarning[0].id } }" target="_blank">#{{toursConfirmedWarning[0].id | uuid}}</b-link>
                &raquo;
                <span v-translate="{count: toursConfirmedWarning[0].count}">%{count} shipments</span>
                <span v-if="toursConfirmedWarning[0].courier_id">&raquo;
                  <b-link :to="{ name: 'UsersEdit', params: { id: toursConfirmedWarning[0].courier_id } }" target="_blank" v-if="toursConfirmedWarning[0].courier_id">{{toursConfirmedWarning[0].courier.name}}</b-link> <a v-if="toursConfirmedWarning[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursConfirmedWarning[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursConfirmedWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalTourConfirmedDetail @click.prevent="showingToursConfirmed = toursConfirmedSuccess"><b-badge variant="success">{{toursConfirmedSuccess.length}}</b-badge> &lt; 30 min</b-link></span>
              <span v-if="toursConfirmedSuccess.length === 1 && toursConfirmedSuccess[0].type === 'tour'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ToursEdit', params: { id: toursConfirmedSuccess[0].id } }" target="_blank">#{{toursConfirmedSuccess[0].id | uuid}}</b-link>
                &raquo;
                <span v-translate="{count: toursConfirmedSuccess[0].count}">%{count} shipments</span>
                <span v-if="toursConfirmedSuccess[0].courier_id">&raquo;
                  <b-link :to="{ name: 'UsersEdit', params: { id: toursConfirmedSuccess[0].courier_id } }" target="_blank" v-if="toursConfirmedSuccess[0].courier_id">{{toursConfirmedSuccess[0].courier.name}}</b-link> <a v-if="toursConfirmedSuccess[0].courier.phone" class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" :href="$options.filters.whatsappize(toursConfirmedSuccess[0].courier.phone)">WhatsApp</a>
                </span>
                &raquo;
                {{elapsedTime(toursConfirmedSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>
        <b-card>
          <b-card-title v-translate>Shippings INTRANSIT</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingIntransitDetail @click.prevent="showingConfirmed = shippingsIntransitDanger"><b-badge variant="danger">{{shippingsIntransitDanger.length}}</b-badge> +48 hs</b-link></span>
              <span v-if="shippingsIntransitDanger.length === 1 && shippingsIntransitDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsIntransitDanger[0].id } }" target="_blank">#{{shippingsIntransitDanger[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsIntransitDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingIntransitDetail @click.prevent="showingConfirmed = shippingsIntransitWarning"><b-badge variant="danger">{{shippingsIntransitWarning.length}}</b-badge> +24 hs</b-link></span>
              <span v-if="shippingsIntransitWarning.length === 1 && shippingsIntransitWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsIntransitWarning[0].id } }" target="_blank">#{{shippingsIntransitWarning[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsIntransitWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingIntransitDetail @click.prevent="showingConfirmed = shippingsIntransitSuccess"><b-badge variant="warning">{{shippingsIntransitSuccess.length}}</b-badge> +12 hs</b-link></span>
              <span v-if="shippingsIntransitSuccess.length === 1 && shippingsIntransitSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsIntransitSuccess[0].id } }" target="_blank">#{{shippingsIntransitSuccess[0].id | uuid}}</b-link>
                &raquo;
                {{elapsedTime(shippingsIntransitSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title v-translate>Shippings ATDELIVERYPOINT</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtDeliveryPointDetail @click.prevent="showingAtDeliveryPoint = shippingsAtDeliveryPointDanger"><b-badge variant="danger">{{shippingsAtDeliveryPointDanger.length}}</b-badge> > 60 min</b-link></span>
              <span v-if="shippingsAtDeliveryPointDanger.length === 1 && shippingsAtDeliveryPointDanger[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsAtDeliveryPointDanger[0].id } }" target="_blank">#{{shippingsAtDeliveryPointDanger[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsAtDeliveryPointDanger[0].created_by_type === 'company' ? 'CompaniesEdit' : 'UsersEdit', params: { id: shippingsAtDeliveryPointDanger[0].created_by_id } }" target="_blank" v-if="shippingsAtDeliveryPointDanger[0].created_by_id">#{{shippingsAtDeliveryPointDanger[0].created_by_id}}</b-link> {{shippingsAtDeliveryPointDanger[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsAtDeliveryPointDanger[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtDeliveryPointDetail @click.prevent="showingAtDeliveryPoint = shippingsAtDeliveryPointWarning"><b-badge variant="warning">{{shippingsAtDeliveryPointWarning.length}}</b-badge> > 30 min</b-link></span>
              <span v-if="shippingsAtDeliveryPointWarning.length === 1 && shippingsAtDeliveryPointWarning[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsAtDeliveryPointWarning[0].id } }" target="_blank">#{{shippingsAtDeliveryPointWarning[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsAtDeliveryPointWarning[0].created_by_type === 'company' ? 'CompaniesEdit' : 'UsersEdit', params: { id: shippingsAtDeliveryPointWarning[0].created_by_id } }" target="_blank" v-if="shippingsAtDeliveryPointWarning[0].created_by_id">#{{shippingsAtDeliveryPointWarning[0].created_by_id}}</b-link> {{shippingsAtDeliveryPointWarning[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsAtDeliveryPointWarning[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalShippingAtDeliveryPointDetail @click.prevent="showingAtDeliveryPoint = shippingsAtDeliveryPointSuccess"><b-badge variant="success">{{shippingsAtDeliveryPointSuccess.length}}</b-badge> &lt; 30 min</b-link></span>
              <span v-if="shippingsAtDeliveryPointSuccess.length === 1 && shippingsAtDeliveryPointSuccess[0].type === 'shipping'" class="align-self-center ml-3">
                <b-link :to="{ name: 'ShippingsEdit', params: { id: shippingsAtDeliveryPointSuccess[0].id } }" target="_blank">#{{shippingsAtDeliveryPointSuccess[0].id | uuid}}</b-link>
                &raquo;
                <b-link :to="{ name: shippingsAtDeliveryPointSuccess[0].created_by_type === 'company' ? 'CompaniesEdit' : 'UsersEdit', params: { id: shippingsAtDeliveryPointSuccess[0].created_by_id } }" target="_blank" v-if="shippingsAtDeliveryPointSuccess[0].created_by_id">#{{shippingsAtDeliveryPointSuccess[0].created_by_id}}</b-link> {{shippingsAtDeliveryPointSuccess[0].created_by_name}}
                &raquo;
                {{elapsedTime(shippingsAtDeliveryPointSuccess[0].updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
              </span>
            </b-row>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title v-translate>Idle Couriers</b-card-title>
          <b-card-text>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIdleCouriersDetail @click.prevent="showingIdleCouriers = idleCouriersDanger"><b-badge variant="danger">{{idleCouriersDanger.length}}</b-badge> > 90 min</b-link></span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIdleCouriersDetail @click.prevent="showingIdleCouriers = idleCouriersWarning"><b-badge variant="warning">{{idleCouriersWarning.length}}</b-badge> > 60 min</b-link></span>
            </b-row>
            <b-row>
              <span class="h4 ml-3"><b-link v-b-modal.modalIdleCouriersDetail @click.prevent="showingIdleCouriers = idleCouriersSuccess"><b-badge variant="success">{{idleCouriersSuccess.length}}</b-badge> > 30 min</b-link></span>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-modal id="modalShippingConfirmedDetail" ref="modalShippingConfirmedDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping CONFIRMED Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingConfirmed" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'ShippingsEdit', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <user-card :user="item.courier" :with-titles="false" :profile-picture="false" :vehicle-types-prop="vehicleTypes" />
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
        </b-row>
      </b-card>
      <h3 v-if="showingConfirmed.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalTourConfirmedDetail" ref="modalTourConfirmedDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Tour CONFIRMED Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingToursConfirmed" :key="index">
        <b-row v-if="item.type === 'tour'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'ToursEdit', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col cols="2">
            <span v-translate="{count: item.count}">%{count} shipments</span><br>
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <user-card :user="item.courier" :with-titles="false" :profile-picture="false" :vehicle-types-prop="vehicleTypes" />
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
        </b-row>
      </b-card>
      <h3 v-if="showingToursConfirmed.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalShippingAtPickupPointDetail" ref="modalShippingAtPickupPointDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping ATPICKUPPOINT Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingAtPickupPoint" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'ShippingsEdit', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <user-card :user="item.courier" :with-titles="false" :profile-picture="false" :vehicle-types-prop="vehicleTypes" />
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; right: 0; padding: 0 5px; line-height: 1.2" class="bg-info text-white" v-if="item.tourId">
            <b-link :to="{ name: 'ToursEdit', params: { id: item.tourId } }" target="_blank" class="text-white"><small v-translate>In Tour</small></b-link>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="showingAtPickupPoint.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalShippingIntransitDetail" ref="modalShippingIntransitDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping INTRANSIT Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingConfirmed" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'ShippingsEdit', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <user-card :user="item.courier" :with-titles="false" :profile-picture="false" :vehicle-types-prop="vehicleTypes" />
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; right: 0; padding: 0 5px; line-height: 1.2" class="bg-info text-white" v-if="item.tourId">
            <b-link :to="{ name: 'ToursEdit', params: { id: item.tourId } }" target="_blank" class="text-white"><small v-translate>In Tour</small></b-link>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="showingConfirmed.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalShippingAtDeliveryPointDetail" ref="modalShippingAtDeliveryPointDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shipping ATDELIVERYPOINT Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-card v-for="(item, index) in showingAtDeliveryPoint" :key="index">
        <b-row v-if="item.type === 'shipping'">
          <b-col cols="3">
            <div style="width: 1rem; height: 1rem; display: inline-block" :class="'bg-' + item.label"></div>
            <b-link :to="{ name: 'ShippingsEdit', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
          </b-col>
          <b-col v-if="item.courier_id && item.courier">
            <user-card :user="item.courier" :with-titles="false" :profile-picture="false" :vehicle-types-prop="vehicleTypes" />
          </b-col>
          <b-col cols="2">
            {{elapsedTime(item.updated_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
          </b-col>
          <div style="position: absolute; top: 0; right: 0; padding: 0 5px; line-height: 1.2" class="bg-info text-white" v-if="item.tourId">
            <b-link :to="{ name: 'ToursEdit', params: { id: item.tourId } }" target="_blank" class="text-white"><small v-translate>In Tour</small></b-link>
          </div>
        </b-row>
      </b-card>
      <h3 v-if="showingAtDeliveryPoint.length === 0" v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalIncidencesDetail" ref="modalIncidencesDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>Shippings on INCIDENCE Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div v-if="incidencesCount[showIncidencesId] > 0">
        <b-card v-for="(item, index) in incidences[showIncidencesId]" :key="index">
          <b-row>
            <b-col cols="3">
              <b-link :to="{ name: 'ShippingsEdit', params: { id: item.id } }" target="_blank">#{{item.id | uuid}}</b-link>
            </b-col>
            <b-col v-if="item.courier_id && item.courier">
              <user-card :user="item.courier" :with-titles="false" :profile-picture="false" :vehicle-types-prop="vehicleTypes" />
            </b-col>
            <b-col cols="2">
              {{elapsedTime(item.status_history[0].created_at, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
            </b-col>
          </b-row>
        </b-card>
      </div>
      <h3 v-else v-translate>No data</h3>
    </b-modal>

    <b-modal id="modalIdleCouriersDetail" ref="modalIdleCouriersDetail" size="lg" :hide-footer="true">
      <div slot="modal-title" v-translate>IDLE Couriers Details</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div v-if="showingIdleCouriers.length > 0">
        <b-card v-for="(item, index) in showingIdleCouriers" :key="index">
          <b-row>
            <b-col>
              <user-card :user='item' :vehicle-types-prop="vehicleTypes" />
            </b-col>
            <b-col cols="3">
              {{elapsedTime(item.last_shipping_status, moment().utc().format('YYYY-MM-DD HH:mm:ss'))}}
            </b-col>
          </b-row>
        </b-card>
      </div>
      <h3 v-else v-translate>No data</h3>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: 'ControlPanelPage',
  title() {
    return this.$gettext('Control')
  },
  data() {
    return {
      confirmeds: {
        shippings: [],
        tours: []
      },
      atPickupPoints: {
        shippings: [],
        tours: []
      },
      intransits: {
        shippings: [],
        tours: []
      },
      atDeliveryPoints: {
        shippings: [],
        tours: []
      },
      showingConfirmed: [],
      showingToursConfirmed: [],
      showingAtPickupPoint: [],
      showingAtDeliveryPoint: [],
      incidences: [],
      incidencesCount: [],
      idleCouriers: [],
      showingIdleCouriers: [],
      showIncidencesId: null
    }
  },
  computed: {
    shippingsConfirmedDanger() {
      return this.confirmeds.shippings.filter(x => x.label === 'danger')
    },
    shippingsConfirmedWarning() {
      return this.confirmeds.shippings.filter(x => x.label === 'warning')
    },
    shippingsConfirmedSuccess() {
      return this.confirmeds.shippings.filter(x => x.label === 'success')
    },
    toursConfirmedDanger() {
      return this.confirmeds.tours.filter(x => x.label === 'danger')
    },
    toursConfirmedWarning() {
      return this.confirmeds.tours.filter(x => x.label === 'warning')
    },
    toursConfirmedSuccess() {
      return this.confirmeds.tours.filter(x => x.label === 'success')
    },
    shippingsAtPickupPointDanger() {
      return this.atPickupPoints.shippings.filter(x => x.label === 'danger')
    },
    shippingsAtPickupPointWarning() {
      return this.atPickupPoints.shippings.filter(x => x.label === 'warning')
    },
    shippingsAtPickupPointSuccess() {
      return this.atPickupPoints.shippings.filter(x => x.label === 'success')
    },
    shippingsIntransitDanger() {
      return this.intransits.shippings.filter(x => x.label === 'danger')
    },
    shippingsIntransitWarning() {
      return this.intransits.shippings.filter(x => x.label === 'warning')
    },
    shippingsIntransitSuccess() {
      return this.intransits.shippings.filter(x => x.label === 'success')
    },
    shippingsAtDeliveryPointDanger() {
      return this.atDeliveryPoints.shippings.filter(x => x.label === 'danger')
    },
    shippingsAtDeliveryPointWarning() {
      return this.atDeliveryPoints.shippings.filter(x => x.label === 'warning')
    },
    shippingsAtDeliveryPointSuccess() {
      return this.atDeliveryPoints.shippings.filter(x => x.label === 'success')
    },
    idleCouriersDanger() {
      return this.idleCouriers.filter(x => x.idle >= 90)
    },
    idleCouriersWarning() {
      return this.idleCouriers.filter(x => x.idle >= 60 && x.idle < 90)
    },
    idleCouriersSuccess() {
      return this.idleCouriers.filter(x => x.idle < 60)
    }
  },
  methods: {
    statusEnteredAt(shipping, status) {
      return shipping.status_history && shipping.status_history.length > 0 && shipping.status_history[0].status === status ? shipping.status_history[0].created_at : shipping.updated_at
    },
    latestStatus(shipping) {
      return shipping.status_history && shipping.status_history.length > 0 ? shipping.status_history[0].status : shipping.status
    },
    elapsedLabel(date) {
      if (this.moment.utc(date) < this.moment().utc().subtract(60, 'minutes')) {
        return 'danger'
      }
      if (this.moment.utc(date) < this.moment().utc().subtract(30, 'minutes')) {
        return 'warning'
      }
      return 'success'
    },
    creatorOf(shipping) {
      return {
        created_by_id: shipping.company ? shipping.company.id : (shipping.user ? shipping.user.id : null),
        created_by_name: shipping.company ? shipping.company.name : (shipping.user ? shipping.user.name : this.$gettext('Moova')),
        created_by_type: shipping.company ? 'company' : 'particular'
      }
    },
    isOwnTour(shipping) {
      return !!(this.ecosystemModules.tours.self && shipping.tour_id && shipping.tour && shipping.tour.courier_company_id === this.profile.company_id)
    },
    getConfirmeds() {
      const params = {
        includes: ['company', 'status_history', 'user', 'courier', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'CONFIRMED']
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings', { params })
        .then(response => {
          Object.assign(this.$data.confirmeds, this.$options.data.call(this).confirmeds)
          for (const shipping of response.body.data) {
            const enteredAt = this.statusEnteredAt(shipping, 'CONFIRMED')
            if (this.isOwnTour(shipping)) {
              const tourIndex = this.confirmeds.tours.findIndex(x => x.id === shipping.tour_id)
              if (tourIndex === -1) {
                this.confirmeds.tours.push({
                  id: shipping.tour_id,
                  type: 'tour',
                  updated_at: enteredAt,
                  count: 1,
                  courier_id: shipping.courier_id,
                  courier: shipping.courier,
                  status: this.latestStatus(shipping),
                  label: this.elapsedLabel(enteredAt)
                })
              } else {
                this.confirmeds.tours[tourIndex].count++
              }
            } else {
              this.confirmeds.shippings.push({
                id: shipping.id,
                type: 'shipping',
                updated_at: enteredAt,
                ...this.creatorOf(shipping),
                courier_id: shipping.courier_id,
                courier: shipping.courier,
                status: this.latestStatus(shipping),
                label: shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().utc() ? 'dark' : this.elapsedLabel(enteredAt)
              })
            }
          }
          this.getAtPickupPoints()
        })
    },
    getAtPickupPoints() {
      const params = {
        includes: ['company', 'status_history', 'user', 'courier', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'ATPICKUPPOINT']
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings', { params })
        .then(response => {
          Object.assign(this.$data.atPickupPoints, this.$options.data.call(this).atPickupPoints)
          for (const shipping of response.body.data) {
            const enteredAt = this.statusEnteredAt(shipping, 'ATPICKUPPOINT')
            this.atPickupPoints.shippings.push({
              id: shipping.id,
              type: 'shipping',
              updated_at: enteredAt,
              ...this.creatorOf(shipping),
              courier_id: shipping.courier_id,
              courier: shipping.courier,
              status: this.latestStatus(shipping),
              tourId: shipping.tour_id || null,
              label: shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().utc() ? 'dark' : this.elapsedLabel(enteredAt)
            })
          }
          this.getIntransits()
        })
    },
    getIntransits() {
      const params = {
        includes: ['company', 'status_history', 'user', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'INTRANSIT'],
              ['updated_at', 'lte', this.moment().utc().subtract(12, 'hour').format('YYYY-MM-DD HH:mm:ss')]
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings', { params })
        .then(response => {
          Object.assign(this.$data.intransits, this.$options.data.call(this).intransits)
          for (const shipping of response.body.data) {
            const enteredAt = this.statusEnteredAt(shipping, 'INTRANSIT')
            const intransit = {
              id: shipping.id,
              type: 'shipping',
              updated_at: enteredAt,
              ...this.creatorOf(shipping),
              courier_id: shipping.courier_id,
              courier: shipping.courier,
              status: this.latestStatus(shipping),
              tourId: shipping.tour_id || null
            }
            if (this.moment.utc(enteredAt) < this.moment().utc().subtract(48, 'hours')) {
              intransit.label = 'danger'
            } else if (this.moment.utc(enteredAt) < this.moment().utc().subtract(24, 'hours')) {
              intransit.label = 'warning'
            } else {
              intransit.label = 'success'
            }

            this.intransits.shippings.push(intransit)
          }
          this.getAtDeliveryPoints()
        })
    },
    getAtDeliveryPoints() {
      const params = {
        includes: ['company', 'status_history', 'user', 'courier', 'tour'],
        page: 0,
        limit: 500,
        sort: [{
          key: 'updated_at',
          direction: 'asc'
        }],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'ATDELIVERYPOINT']
              // ['status_history.status', 'in', ['WAITING']]
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings', { params })
        .then(response => {
          Object.assign(this.$data.atDeliveryPoints, this.$options.data.call(this).atDeliveryPoints)
          for (const shipping of response.body.data) {
            const enteredAt = this.statusEnteredAt(shipping, 'ATDELIVERYPOINT')
            this.atDeliveryPoints.shippings.push({
              id: shipping.id,
              type: 'shipping',
              updated_at: enteredAt,
              ...this.creatorOf(shipping),
              courier_id: shipping.courier_id,
              courier: shipping.courier,
              status: this.latestStatus(shipping),
              tourId: shipping.tour_id || null,
              label: shipping.scheduled_date && this.moment.utc(shipping.scheduled_date) > this.moment().utc() ? 'dark' : this.elapsedLabel(enteredAt)
            })
          }
          this.fetchIdles()
        })
    },
    fectchIncidences(id) {
      const params = {
        incidence_type_id: id,
        includes: [
          'status_history',
          'user',
          'company'
        ],
        date_to: this.moment().format('YYYY-MM-DD'),
        date_from: this.moment().format('YYYY-MM-DD'),
        sort: [
          {
            key: 'incidence_count',
            direction: 'desc'
          },
          {
            key: 'updated_at',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'INCIDENCE']
            ]
          }
        ]
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shippings/with-incidence?incidence_type_id=' + id + '&status=INCIDENCE&includes[]=status_history&includes[]=user&includes[]=company', { params })
        .then(response => {
          if (typeof this.incidencesCount !== 'undefined' && typeof this.incidencesCount[id] !== 'undefined') {
            this.incidencesCount[id] = []
          }
          if (typeof this.incidences !== 'undefined' && typeof this.incidences[id] !== 'undefined') {
            this.incidences[id] = []
          }

          this.$set(this.incidencesCount, id, response.body.pagination.total)
          this.$set(this.incidences, id, response.body.data)
        })
    },
    fetchIdles() {
      const params = {
        minutes: 30,
        filter_groups: []
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/couriers-idle', { params })
        .then(response => {
          response.body.data.forEach((item, i) => {
            response.body.data[i].idle = (this.moment().utc() - this.moment.utc(item.last_shipping_status)) / 1000 / 60
          })
          this.idleCouriers = response.body.data.sort((a, b) => (a.idle < b.idle) ? 1 : -1)
        })
    }
  }
}
</script>
